var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHelpIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.031,
    height: 15.01,
    viewBox: "0 0 15.031 15.01",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_6670",
    "data-name": "Group 6670",
    transform: "translate(4340 10084)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6669",
    "data-name": "Group 6669",
    transform: "translate(2097 -698)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_618",
    "data-name": "Rectangle 618",
    width: 15,
    height: 15,
    transform: "translate(-6437 -9386)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6668",
    "data-name": "Group 6668",
    transform: "translate(-0.156 -0.179)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_428",
    "data-name": "Path 428",
    d: "M14.252,10.762v1.924c0,.876-1,1.586-2.244,1.586H2.244C1,14.271,0,13.561,0,12.685V1.586C0,.71,1,0,2.244,0h9.765c1.239,0,2.244.71,2.244,1.586V3.456",
    transform: "translate(-4325.188 -10083.438) rotate(90)",
    fill: "none",
    stroke: "#14a4c2",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_6667",
    "data-name": "Group 6667",
    transform: "translate(-4335.942 -10081.587)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1090",
    "data-name": "Group 1090"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_879",
    "data-name": "Path 879",
    d: "M8.81,16.377a.75.75,0,0,1-.729-.729A4.7,4.7,0,0,1,8.2,14.1c.011-.038.021-.078.032-.119a3.089,3.089,0,0,1,.28-.764,6.466,6.466,0,0,1,1.312-1.523,5.158,5.158,0,0,0,1.23-1.6,1.836,1.836,0,0,0,.156-1.314,2.456,2.456,0,0,0-.918-1.08,3.737,3.737,0,0,0-1.735-.2,3.848,3.848,0,0,0-.616.21,1.834,1.834,0,0,0-.455.323,2.27,2.27,0,0,0-.526,1.38.749.749,0,0,1-.763.739.758.758,0,0,1-.7-.808,3.854,3.854,0,0,1,.924-2.374,3.216,3.216,0,0,1,.83-.626,4.925,4.925,0,0,1,1-.359l.04-.01L8.34,5.97a5,5,0,0,1,2.653.368l.041.022.038.027a4.025,4.025,0,0,1,1.465,1.74,2.72,2.72,0,0,1,.178,1.417,4.124,4.124,0,0,1-.344,1.223,6.6,6.6,0,0,1-1.591,2.1,5.087,5.087,0,0,0-1.018,1.155,2.127,2.127,0,0,0-.12.375c-.012.046-.025.093-.038.14a3.167,3.167,0,0,0-.064,1.024.759.759,0,0,1-.687.817Z",
    transform: "translate(-5.5 -5.93)",
    fill: "#fcb364"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_52",
    "data-name": "Ellipse 52",
    cx: 0.585,
    cy: 0.619,
    rx: 0.585,
    ry: 0.619,
    transform: "translate(2.767 11.527)",
    fill: "#14a4c2"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelpIcon);
export default __webpack_public_path__ + "static/media/Help Icon.703e664b188271fb2b0d826579d1e16a.svg";
export { ForwardRef as ReactComponent };